import { useEffect } from 'react'
import { useAppDispatch, useAppSelector } from '@/store/store-hooks'
import { RootState } from '@/store/store'
import { MedSummaryAssetActions } from '../store/slice'

type MedSummaryAssetRootProps = {
  children: React.ReactNode
}

/**
 * Root wrapper for the living billing summary routes.
 * Loads the active matter's billing summary (and resumes any in-flight update polling).
 */
export default function MedSummaryAssetRoot({ children }: MedSummaryAssetRootProps) {
  const dispatch = useAppDispatch()
  const activeMatterId = useAppSelector((state: RootState) => state.mattersState.activeMatterId)

  useEffect(() => {
    if (activeMatterId) {
      dispatch(MedSummaryAssetActions.fetchAssetForMatter({ matterId: activeMatterId }))
    }
  }, [dispatch, activeMatterId])

  return <>{children}</>
}
